import { ref, onMounted, onBeforeUnmount } from 'vue'

/**
 * Composable: реактивный таймер для ETA-вычислений.
 * Обновляет `now` каждые intervalMs мс.
 */
export function useEtaTimer(intervalMs = 3000) {
  const now = ref(Date.now())
  let timer = null

  onMounted(() => {
    timer = setInterval(() => { now.value = Date.now() }, intervalMs)
  })

  onBeforeUnmount(() => {
    if (timer) clearInterval(timer)
  })

  return { now }
}
